var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompaniesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.591 1.16h-.464v.464h.464V1.16zM4.84 2.884h-.464v.464h.464v-.464zM1.591 2.155h-.464v.464h.464v-.464zM4.84 3.879h-.464v.464h.464v-.464zM2.586 1.16h-.464v.464h.464V1.16zM2.586 2.155h-.464v.464h.464v-.464z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.827 2.055H3.68V.173A.173.173 0 0 0 3.507 0H.173A.173.173 0 0 0 0 .173v4.844c0 .096.077.173.173.173h5.654A.173.173 0 0 0 6 5.017V2.228a.173.173 0 0 0-.173-.173zM5.536 4.74l-1.858.005V2.522l1.858-.005V4.74zm-2.32-2.486v2.59l-.929-.001V3.68H1.36v1.16H.464V.463L3.215.47v1.785z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIcon);
export default __webpack_public_path__ + "static/media/companies_icon.5546c73ed139f3d9acc9893f1bf419ea.svg";
export { ForwardRef as ReactComponent };